/* Sleep homepage — the science. Each figure plays problem (amber) -> fix (teal), holds the fix, dims, resets and plays again,
   for as long as it is on screen. Off screen it stops where it is and picks up when it comes back.
   The motion itself is CSS (transform / opacity / stroke-dashoffset only); this file only switches classes.
   No JS, no IntersectionObserver or reduced motion = figures rest in the fixed state. */
(function () {
  'use strict';
  var FIRST = 650, HOLD_FIX = 3600, FADE = 450, HOLD_PROBLEM = 1300;
  function init(main, DTS) {
    var root = main.querySelector('[data-dts-pillars]');
    if (!root || DTS.reduce || !('IntersectionObserver' in window)) return;
    var figs = [].slice.call(root.querySelectorAll('[data-dts-fig]'));

    function loop(el, idx) {
      var st = { on: false, t: 0, step: 'problem', seen: false };
      function later(fn, ms) { clearTimeout(st.t); st.t = setTimeout(function () { if (st.on) fn(); }, ms); }
      function toFix() {
        st.step = 'fix'; el.classList.add('is-in');
        if (!st.seen) { st.seen = true; if (DTS.track) DTS.track('pillar_seen', { figure: el.getAttribute('data-dts-fig') }); }
        later(toReset, HOLD_FIX);
      }
      function toReset() {
        st.step = 'reset'; el.classList.add('is-reset');
        later(function () {
          el.classList.remove('is-in');
          // let the snap to the problem state commit while hidden, then fade it back in
          later(function () { el.classList.remove('is-reset'); st.step = 'problem'; later(toFix, HOLD_PROBLEM + FADE); }, 60);
        }, FADE);
      }
      return {
        show: function () {
          if (st.on) return; st.on = true;
          if (st.step === 'fix') later(toReset, HOLD_FIX);
          else { el.classList.remove('is-reset'); el.classList.remove('is-in'); st.step = 'problem'; later(toFix, st.seen ? HOLD_PROBLEM : FIRST + (window.innerWidth >= 990 ? idx * 260 : 0)); }
        },
        hide: function () { st.on = false; clearTimeout(st.t); }
      };
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var l = en.target.__dtsLoop; if (!l) return;
        if (en.isIntersecting && en.intersectionRatio >= 0.4) l.show(); else if (!en.isIntersecting || en.intersectionRatio < 0.1) l.hide();
      });
    }, { threshold: [0, 0.1, 0.4, 0.75] });
    figs.forEach(function (el, i) { el.classList.add('is-armed'); el.__dtsLoop = loop(el, i); io.observe(el); });
  }
  var D = (window.DTS = window.DTS || {});
  if (D.register) D.register('pillars', init); else (D.modules = D.modules || []).push({ name: 'pillars', fn: init });
})();
